module.exports = __webpack_public_path__ + "img/hrb_top_dh.77017f98.png";